import TextAnswer from './TextAnswer.component';

export default TextAnswer;
